import { render, staticRenderFns } from "./WDVsaQuoteLeadsLogs.vue?vue&type=template&id=b79856ae&"
import script from "./WDVsaQuoteLeadsLogs.vue?vue&type=script&lang=js&"
export * from "./WDVsaQuoteLeadsLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports